import React, { useEffect, useState } from 'react';
import { Helmet } from 'react-helmet';
import { useHistory, useParams } from 'react-router-dom';

import { Typography } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';

import ResetPasswordForm from '../../components/public/ResetPasswordForm.component';
import { PUBLIC_AUTHENTICATION_APP_PATHS } from '../../constants/authentication-paths.constants';

const RESET_PASSWORD_BASE_PATH = PUBLIC_AUTHENTICATION_APP_PATHS.RESET_PASSWORD.replace('/:token', '');

const useStyles = makeStyles((theme) => ({
  wrapper: { display: 'flex', justifyContent: 'center', padding: theme.spacing(6, 3) },
  column: { width: '100%', maxWidth: 440 },
  title: {
    fontFamily: 'Bitter, serif',
    fontWeight: 700,
    marginBottom: theme.spacing(3),
    color: theme.palette.client.primary.extraDark,
  },
}));

const ResetPasswordView: React.FC = () => {
  const classes = useStyles();
  const history = useHistory();
  const { token } = useParams<{ token: string }>();
  const [storedToken] = useState(token);

  useEffect(() => {
    history.replace(RESET_PASSWORD_BASE_PATH);
    // eslint-disable-next-line
  }, []);

  const onSuccess = () => history.push(PUBLIC_AUTHENTICATION_APP_PATHS.LOGIN);

  return (
    <React.Fragment>
      <Helmet>
        <title>Réinitialiser le mot de passe - Bio Culture</title>
        <meta name="robots" content="noindex" />
      </Helmet>

      <div className={classes.wrapper}>
        <div className={classes.column}>
          <Typography variant="h4" component="h1" className={classes.title}>
            Réinitialiser le mot de passe
          </Typography>

          <ResetPasswordForm token={storedToken} onSuccess={onSuccess} />
        </div>
      </div>
    </React.Fragment>
  );
};

export default ResetPasswordView;
